import { type GridColDef } from "@mui/x-data-grid";

import { ProjectPersonnel } from "api/memberPortal/project/personnel/personnel.types";

export const proposedValTeamColumns: GridColDef<ProjectPersonnel>[] = [
  {
    field: "vid",
    headerName: "VID",
    flex: 1,
    valueGetter: (_value, row) => row.product_id.v_id,
  },
  {
    field: "firstName",
    headerName: "First Name",
    flex: 1,
    valueGetter: (_value, row) => row.user_id?.first_name || "",
  },
  {
    field: "lastName",
    headerName: "Last Name",
    flex: 1,
    valueGetter: (_value, row) => row.user_id?.last_name || "",
  },
  { field: "role", headerName: "Role", flex: 1 },
];
